import { httpClient } from "../http/httpClient";

export interface CreateSimulationsRequest {
  cpf: string;
  isRefinancing: boolean;
  phone: string;
}

type DadosConsentimento = {
  consentimentoId: string;
  linkConsentimento: string;
  consentimentoPendente: boolean;
  codigoBanco: string;
  nomeBanco: string;
  agencia: string;
  conta: string;
  digitoConta: string;
  tipoConta: string;
};

export type Simulacao = {
  idSimulacao: string;
  idContratoRefin: string;
  codigoParceiro: number;
  tipoOperacao: number;
  codigoDataRecebimentoId: number;
  dataLiberacao: string;
  valorSolicitado: number;
  valorParcela: number;
  dataPrimeiroVencimento: string;
  quantidadeParcelas: number;
  valorCreditado: number;
};

export interface CreateSimulationsResponse {
  sucesso: boolean;
  valorLimiteTomado: number;
  mensagemLimiteTomado: string;
  matricula: string;
  digitoMatricula: string;
  renda: number;
  informacao: string;
  openFinanceObrigatorio: boolean;
  dadosConsentimento?: DadosConsentimento;
  consentimentoPendente?: boolean;
  consentimentoId?: string;
  linkConsentimento?: string;
  simulacoes: Simulacao[];
  commission: number;
  installment: number;
}

export async function createSimulations(
  clientId: string,
  data: CreateSimulationsRequest,
) {
  const response = await httpClient
    .post<CreateSimulationsResponse>(`/crefisa/simulation/${clientId}`, data)
    .catch((error) => {
      throw error.response?.data || error;
    });
  return response.data;
}
